// PM POSHAN MDM Calculator — Data (ported from original data.js)
// Lifetime rate periods, laddoo policy, weekday menus and per-student norms

export const MENU_PLANS = {
  1: { items: ["Rice 🍚", "Egg Curry 🥚"], display: "Rice + Egg Curry" },
  2: { items: ["Rice 🍚", "Soya Badi Curry 🧆", "Nutrition-Rich Laddoo 🧁"], display: "Rice + Soya Badi Curry + Nutrition Laddoo" },
  3: { items: ["Rice 🍚", "Egg Curry 🥚"], display: "Rice + Egg Curry" },
  4: { items: ["Rice 🍚", "Dalma 🫘", "Nutrition-Rich Laddoo 🧁"], display: "Rice + Dalma + Nutrition Laddoo" },
  5: { items: ["Rice 🍚", "Egg Curry 🥚"], display: "Rice + Egg Curry" },
  6: { items: ["Rice 🍚", "Soya Badi Curry 🧆", "Nutrition-Rich Laddoo 🧁"], display: "Rice + Soya Badi Curry + Nutrition Laddoo" },
  0: { items: ["Rice 🍚", "Special Menu 🍽️"], display: "Rice + Special Menu (if served)" },
};

export const LADDOO_POLICY = {
  effective_periods: [
    { start: new Date("2025-04-01"), end: new Date("2030-12-31"), active: true, days: [2, 4, 6], cost_per_piece: 3.5 },
    { start: new Date("2031-01-01"), end: new Date("2035-12-31"), active: true, days: [2, 4, 6], cost_per_piece: 4.0 },
    { start: new Date("2036-01-01"), end: new Date("2040-12-31"), active: true, days: [2, 4, 6], cost_per_piece: 4.5 },
    { start: new Date("2041-01-01"), end: new Date("2045-12-31"), active: true, days: [2, 4, 6], cost_per_piece: 5.0 },
    { start: new Date("2046-01-01"), end: new Date("2050-12-31"), active: true, days: [2, 4, 6], cost_per_piece: 5.5 },
    { start: new Date("2051-01-01"), end: null,                       active: true, days: [2, 4, 6], cost_per_piece: 6.0 },
  ],
};

export const LADDOO_INGREDIENTS = {
  "Ragi flour":  { quantity_g: 12,   cost_rs: 1.8 },
  "Groundnut":   { quantity_g: 0.5,  cost_rs: 0.12 },
  "Sesame":      { quantity_g: 1,    cost_rs: 0.14 },
  "Sugar":       { quantity_g: 6,    cost_rs: 0.27 },
  "Refined oil": { quantity_g: 2,    cost_rs: 0.32 },
  "Cardamom":    { quantity_g: 0.04, cost_rs: 0.06 },
  "Preparation": { quantity_g: 0,    cost_rs: 0.26 },
};

export const RICE_QUANTITIES = { balvatika: 100, primary: 100, upper_primary: 150, high_school: 150 };

// Weekday-specific item visibility (May 2025+)
export const WEEKDAY_ITEMS = {
  1: ["Rice", "Egg", "Oil", "Vegetables", "Condiment & Salt", "Fuel"],
  2: ["Rice", "Soya", "Oil", "Vegetables", "Condiment & Salt", "Laddoo", "Fuel"],
  3: ["Rice", "Egg", "Oil", "Vegetables", "Condiment & Salt", "Fuel"],
  4: ["Rice", "Dal", "Oil", "Vegetables", "Condiment & Salt", "Laddoo", "Fuel"],
  5: ["Rice", "Egg", "Oil", "Vegetables", "Condiment & Salt", "Fuel"],
  6: ["Rice", "Soya", "Oil", "Vegetables", "Condiment & Salt", "Laddoo", "Fuel"],
  0: ["Rice", "Dal", "Oil", "Vegetables", "Condiment & Salt", "Fuel"],
};

export const CATEGORY_DISPLAY = {
  balvatika:     { name: "Balvatika",           emoji: "🧒", full: "Balvatika (Pre-school)",  color: "emerald",
                   ui: { chip: "bg-emerald-50 text-emerald-800 border-emerald-200",
                         solid: "bg-emerald-700 text-white",
                         soft:  "bg-emerald-50 border-emerald-200",
                         accent:"text-emerald-700" },
                   pdf: [4, 120, 87] },
  primary:       { name: "Primary (I–V)",       emoji: "🎒", full: "Primary Classes I – V",   color: "orange",
                   ui: { chip: "bg-orange-50 text-orange-800 border-orange-200",
                         solid: "bg-orange-600 text-white",
                         soft:  "bg-orange-50 border-orange-200",
                         accent:"text-orange-700" },
                   pdf: [234, 88, 12] },
  upper_primary: { name: "Upper Primary (VI–VIII)", emoji: "📘", full: "Upper Primary VI – VIII", color: "blue",
                   ui: { chip: "bg-sky-50 text-sky-800 border-sky-200",
                         solid: "bg-sky-700 text-white",
                         soft:  "bg-sky-50 border-sky-200",
                         accent:"text-sky-700" },
                   pdf: [3, 105, 161] },
  high_school:   { name: "High School (IX–X)",  emoji: "🎓", full: "High School IX – X",      color: "rose",
                   ui: { chip: "bg-rose-50 text-rose-800 border-rose-200",
                         solid: "bg-rose-700 text-white",
                         soft:  "bg-rose-50 border-rose-200",
                         accent:"text-rose-700" },
                   pdf: [190, 18, 60] },
};

// Base May 2025 rates (reused across all future periods)
const MAY_2025_RATES = {
  balvatika: {
    target_total: 11.15,
    items: {
      Rice:              { qty_per_student: 100, unit: "g",    rate_per_student: 0.00, emoji: "🍚" },
      Dal:               { qty_per_student: 25,  unit: "g",    rate_per_student: 2.87, emoji: "🫘" },
      Soya:              { qty_per_student: 12,  unit: "g",    rate_per_student: 1.91, emoji: "🧆" },
      Oil:               { qty_per_student: 5,   unit: "g",    rate_per_student: 0.80, emoji: "🛢️" },
      Vegetables:        { qty_per_student: 60,  unit: "g",    rate_per_student: 3.02, emoji: "🥬", auto_balance: true },
      Egg:               { qty_per_student: 1,   unit: "no",   rate_per_student: 7.00, emoji: "🥚" },
      Laddoo:            { qty_per_student: 1,   unit: "no",   rate_per_student: 3.50, emoji: "🧁" },
      "Condiment & Salt":{ qty_per_student: 1,   unit: "unit", rate_per_student: 0.50, emoji: "🧂" },
      Fuel:              { qty_per_student: 1,   unit: "unit", rate_per_student: 1.00, emoji: "🔥" },
    },
  },
  primary: {
    target_total: 11.15,
    items: {
      Rice:              { qty_per_student: 100, unit: "g",    rate_per_student: 0.00, emoji: "🍚" },
      Dal:               { qty_per_student: 25,  unit: "g",    rate_per_student: 2.87, emoji: "🫘" },
      Soya:              { qty_per_student: 12,  unit: "g",    rate_per_student: 1.91, emoji: "🧆" },
      Oil:               { qty_per_student: 5,   unit: "g",    rate_per_student: 0.80, emoji: "🛢️" },
      Vegetables:        { qty_per_student: 60,  unit: "g",    rate_per_student: 3.02, emoji: "🥬", auto_balance: true },
      Egg:               { qty_per_student: 1,   unit: "no",   rate_per_student: 7.00, emoji: "🥚" },
      Laddoo:            { qty_per_student: 1,   unit: "no",   rate_per_student: 3.50, emoji: "🧁" },
      "Condiment & Salt":{ qty_per_student: 1,   unit: "unit", rate_per_student: 0.50, emoji: "🧂" },
      Fuel:              { qty_per_student: 1,   unit: "unit", rate_per_student: 1.00, emoji: "🔥" },
    },
  },
  upper_primary: {
    target_total: 14.74,
    items: {
      Rice:              { qty_per_student: 150, unit: "g",    rate_per_student: 0.00, emoji: "🍚" },
      Dal:               { qty_per_student: 25,  unit: "g",    rate_per_student: 2.87, emoji: "🫘" },
      Soya:              { qty_per_student: 12,  unit: "g",    rate_per_student: 1.91, emoji: "🧆" },
      Oil:               { qty_per_student: 7.5, unit: "g",    rate_per_student: 1.20, emoji: "🛢️" },
      Vegetables:        { qty_per_student: 100, unit: "g",    rate_per_student: 3.02, emoji: "🥬", auto_balance: true },
      Egg:               { qty_per_student: 1,   unit: "no",   rate_per_student: 7.00, emoji: "🥚" },
      Laddoo:            { qty_per_student: 1,   unit: "no",   rate_per_student: 3.50, emoji: "🧁" },
      "Condiment & Salt":{ qty_per_student: 1,   unit: "unit", rate_per_student: 0.75, emoji: "🧂" },
      Fuel:              { qty_per_student: 1,   unit: "unit", rate_per_student: 1.00, emoji: "🔥" },
    },
  },
  high_school: {
    target_total: 14.74,
    items: {
      Rice:              { qty_per_student: 150, unit: "g",    rate_per_student: 0.00, emoji: "🍚" },
      Dal:               { qty_per_student: 25,  unit: "g",    rate_per_student: 2.87, emoji: "🫘" },
      Soya:              { qty_per_student: 12,  unit: "g",    rate_per_student: 1.91, emoji: "🧆" },
      Oil:               { qty_per_student: 7.5, unit: "g",    rate_per_student: 1.20, emoji: "🛢️" },
      Vegetables:        { qty_per_student: 100, unit: "g",    rate_per_student: 3.02, emoji: "🥬", auto_balance: true },
      Egg:               { qty_per_student: 1,   unit: "no",   rate_per_student: 7.00, emoji: "🥚" },
      Laddoo:            { qty_per_student: 1,   unit: "no",   rate_per_student: 3.50, emoji: "🧁" },
      "Condiment & Salt":{ qty_per_student: 1,   unit: "unit", rate_per_student: 0.75, emoji: "🧂" },
      Fuel:              { qty_per_student: 1,   unit: "unit", rate_per_student: 1.00, emoji: "🔥" },
    },
  },
};

// Older (pre-Apr 2025) rates
const PRE_APR_2025_RATES = {
  balvatika: { target_total: null, items: {
    Rice:              { qty_per_student: 100, unit: "g",    rate_per_student: 0.00, emoji: "🍚" },
    Dal:               { qty_per_student: 25,  unit: "g",    rate_per_student: 3.75, emoji: "🫘" },
    Oil:               { qty_per_student: 5,   unit: "g",    rate_per_student: 0.80, emoji: "🛢️" },
    Vegetables:        { qty_per_student: 60,  unit: "g",    rate_per_student: 2.10, emoji: "🥬" },
    Egg:               { qty_per_student: 1,   unit: "no",   rate_per_student: 7.00, emoji: "🥚" },
    "Condiment & Salt":{ qty_per_student: 1,   unit: "unit", rate_per_student: 0.50, emoji: "🧂" },
    Fuel:              { qty_per_student: 1,   unit: "unit", rate_per_student: 1.00, emoji: "🔥" },
  }},
  primary: { target_total: null, items: {
    Rice:              { qty_per_student: 100, unit: "g",    rate_per_student: 0.00, emoji: "🍚" },
    Dal:               { qty_per_student: 25,  unit: "g",    rate_per_student: 3.75, emoji: "🫘" },
    Oil:               { qty_per_student: 5,   unit: "g",    rate_per_student: 0.80, emoji: "🛢️" },
    Vegetables:        { qty_per_student: 60,  unit: "g",    rate_per_student: 2.10, emoji: "🥬" },
    Egg:               { qty_per_student: 1,   unit: "no",   rate_per_student: 7.00, emoji: "🥚" },
    "Condiment & Salt":{ qty_per_student: 1,   unit: "unit", rate_per_student: 0.50, emoji: "🧂" },
    Fuel:              { qty_per_student: 1,   unit: "unit", rate_per_student: 1.00, emoji: "🔥" },
  }},
  upper_primary: { target_total: null, items: {
    Rice:              { qty_per_student: 150, unit: "g",    rate_per_student: 0.00, emoji: "🍚" },
    Dal:               { qty_per_student: 30,  unit: "g",    rate_per_student: 4.50, emoji: "🫘" },
    Oil:               { qty_per_student: 7.5, unit: "g",    rate_per_student: 1.20, emoji: "🛢️" },
    Vegetables:        { qty_per_student: 100, unit: "g",    rate_per_student: 3.50, emoji: "🥬" },
    Egg:               { qty_per_student: 1,   unit: "no",   rate_per_student: 7.00, emoji: "🥚" },
    "Condiment & Salt":{ qty_per_student: 1,   unit: "unit", rate_per_student: 0.75, emoji: "🧂" },
    Fuel:              { qty_per_student: 1,   unit: "unit", rate_per_student: 1.00, emoji: "🔥" },
  }},
  high_school: { target_total: null, items: {
    Rice:              { qty_per_student: 150, unit: "g",    rate_per_student: 0.00, emoji: "🍚" },
    Dal:               { qty_per_student: 30,  unit: "g",    rate_per_student: 4.50, emoji: "🫘" },
    Oil:               { qty_per_student: 7.5, unit: "g",    rate_per_student: 1.20, emoji: "🛢️" },
    Vegetables:        { qty_per_student: 100, unit: "g",    rate_per_student: 3.50, emoji: "🥬" },
    Egg:               { qty_per_student: 1,   unit: "no",   rate_per_student: 7.00, emoji: "🥚" },
    "Condiment & Salt":{ qty_per_student: 1,   unit: "unit", rate_per_student: 0.75, emoji: "🧂" },
    Fuel:              { qty_per_student: 1,   unit: "unit", rate_per_student: 1.00, emoji: "🔥" },
  }},
};

// Apr 2025 only (transitional)
const APR_2025_RATES = JSON.parse(JSON.stringify(MAY_2025_RATES));
// Apr 2025 had no target_total (auto-balance not yet)
["balvatika", "primary", "upper_primary", "high_school"].forEach((c) => {
  APR_2025_RATES[c].target_total = null;
  APR_2025_RATES[c].items.Vegetables.auto_balance = false;
  APR_2025_RATES[c].items.Fuel.rate_per_student = c === "upper_primary" || c === "high_school" ? 1.0 : 0.76;
});

const clone = (o) => JSON.parse(JSON.stringify(o));

export const RATE_PERIODS = [
  { effective_from: new Date("2012-01-01"), effective_to: new Date("2025-03-31"), rates: clone(PRE_APR_2025_RATES) },
  { effective_from: new Date("2025-04-01"), effective_to: new Date("2025-04-30"), rates: clone(APR_2025_RATES) },
  { effective_from: new Date("2025-05-01"), effective_to: new Date("2030-12-31"), rates: clone(MAY_2025_RATES) },
  { effective_from: new Date("2031-01-01"), effective_to: new Date("2035-12-31"), rates: clone(MAY_2025_RATES) },
  { effective_from: new Date("2036-01-01"), effective_to: new Date("2040-12-31"), rates: clone(MAY_2025_RATES) },
  { effective_from: new Date("2041-01-01"), effective_to: new Date("2045-12-31"), rates: clone(MAY_2025_RATES) },
  { effective_from: new Date("2046-01-01"), effective_to: new Date("2050-12-31"), rates: clone(MAY_2025_RATES) },
  { effective_from: new Date("2051-01-01"), effective_to: new Date("2100-12-31"), rates: clone(MAY_2025_RATES) },
];

// ---------- Utilities ----------
export function getEffectivePeriod(date) {
  for (const p of RATE_PERIODS) {
    if (date >= p.effective_from && (p.effective_to === null || date <= p.effective_to)) return p;
  }
  return null;
}

export function isLaddooActive(date, weekday) {
  if (![2, 4, 6].includes(weekday)) return false;
  for (const p of LADDOO_POLICY.effective_periods) {
    if (date >= p.start && (p.end === null || date <= p.end) && p.active && p.days.includes(weekday)) return true;
  }
  return false;
}

export function getLaddooCost(date) {
  for (const p of LADDOO_POLICY.effective_periods) {
    if (date >= p.start && (p.end === null || date <= p.end) && p.active) return p.cost_per_piece;
  }
  return 3.5;
}

export function getMenuDisplay(date) {
  return MENU_PLANS[date.getDay()]?.display || "No menu available";
}

export function isValidServiceDate(date) {
  return date >= new Date("2012-01-01") && date <= new Date("2100-12-31");
}

export function formatCurrency(amt) {
  return `₹${Number(amt).toFixed(2)}`;
}
export function formatQty(q, unit) {
  if (unit === "g" && q >= 1000) return `${(q / 1000).toFixed(2)} kg`;
  return `${q} ${unit}`;
}

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const dayName = (d) => DAY_NAMES[d.getDay()];
